import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "./components/modules/Nav";
import LoginPage from "./components/pages/LoginPage";
import Dashboard from "./components/pages/Dashboard";
import OverallStandings from "./components/pages/OverallStandings";
import Predictions from "./components/pages/Predictions";
import Profile from "./components/pages/Profile";
import Footer from "./components/modules/Footer";
import NotFoundPage from "./components/pages/NotFoundPage";
import "./app.css";
import "./style.css";
import { get } from "./util";
import { GoogleOAuthProvider } from "@react-oauth/google";

const CLIENT_ID =
  "911618425792-hk0acmfunco1f8qg441iih4pvm01cuae.apps.googleusercontent.com";

const App = () => {
  const [user, setUser] = useState();

  useEffect(() => {
    get("/api/whoami").then((user) => {
      setUser(user ?? undefined);
    });
  }, []);

  const updateUser = (user) => setUser(user);

  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <BrowserRouter>
        <Nav user={user} updateUser={updateUser} />
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/dashboard" element={<Dashboard user={user} />} />
          <Route
            path="/overallstandings"
            element={<OverallStandings user={user} />}
          />
          <Route path="/predictions" element={<Predictions user={user} />} />
          <Route path="/profile/:userId" element={<Profile user={user} />} />
          {/* Make sure this is the last route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
};

export default App;
